"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFunctions = void 0;

var _mathjs = require("mathjs");

var _dates = require("../consts/dates");

var _dateUtil = require("../utils/date-util");

function _getMonth(value) {
  var customFunctionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'getMonth';

  if (!value) {
    throw new Error("".concat(customFunctionName, " function: can't get a month from an empty value"));
  }

  if (typeof value !== 'string' || !(0, _dateUtil.isValidDate)(new Date(value))) {
    throw new Error("Non-date value was provided to ".concat(customFunctionName, " function"));
  }

  if (!(0, _dateUtil.isIsoDate)(value)) {
    throw new Error("".concat(customFunctionName, " function expects date to be in yyyy-mm-dd format but got \"").concat(value, "\""));
  }

  return Number(value.substring(5, 7));
}

var dateFunctions = {
  getMonth: function getMonth(value) {
    return _getMonth(value);
  },
  getMonthName: function getMonthName(value) {
    var monthIndex = _getMonth(value, 'getMonthName') - 1; // Shouldn't happen, this check here only for TS types and in case something goes very wrong in getMonth

    if (!(0, _dates.isValidMonthIndex)(monthIndex)) {
      throw new Error("getMonthName function: month index is invalid: ".concat(monthIndex));
    }

    var monthId = _dates.MonthOfYear[monthIndex];
    return _dates.FullMonths[monthId];
  },
  // Have to use mathjs factory function because we need access to mathjs instance inside it.
  // In order to return a unit-aware number (not just primitive), we need to return an instance of mathjs Unit class
  getTimeDiff: (0, _mathjs.factory)('getTimeDiff', ['unit'], // A function or a property available in mathjs namespace, in this case we need `math.unit`
  function (_ref) {
    var unit = _ref.unit;
    return function (arg1, arg2) {
      if (!arg1 || !arg2) {
        throw new Error("getTimeDiff function: can't calculate time difference with an empty value");
      }

      if (typeof arg1 !== 'string' || !(0, _dateUtil.isValidTimeString)(arg1) && !(0, _dateUtil.isValidDateString)(arg1)) {
        throw new Error("getTimeDiff function expects first argument to be a time, date, or datetime but got \"".concat(arg1, "\""));
      }

      if (typeof arg2 !== 'string' || !(0, _dateUtil.isValidTimeString)(arg2) && !(0, _dateUtil.isValidDateString)(arg2)) {
        throw new Error("getTimeDiff function expects second argument to be a time, date, or datetime but got \"".concat(arg2, "\""));
      }

      var date1 = new Date(arg1);
      var date2 = new Date(arg2);

      if ((0, _dateUtil.isValidTimeString)(arg1) && !(0, _dateUtil.isValidTimeString)(arg2) || (0, _dateUtil.isValidDate)(date1) && !(0, _dateUtil.isValidDate)(date2)) {
        throw new Error("getTimeDiff function expects both arguments to be in the same format but got \"".concat(arg1, "\" and \"").concat(arg2, "\""));
      }

      var timeDiff = 0;

      if ((0, _dateUtil.isValidTimeString)(arg1) && (0, _dateUtil.isValidTimeString)(arg2)) {
        var time1MinFromDayStart = (0, _dateUtil.getHoursFromTimeString)(arg1) * 60 + (0, _dateUtil.getMinutesFromTimeString)(arg1);
        var time2MinFromDayStart = (0, _dateUtil.getHoursFromTimeString)(arg2) * 60 + (0, _dateUtil.getMinutesFromTimeString)(arg2);
        timeDiff = Math.abs(time1MinFromDayStart - time2MinFromDayStart);
      } else {
        timeDiff = Math.abs(date1.getTime() - date2.getTime()) / 1000 / 60;
      }

      return unit(timeDiff, 'min');
    };
  })
};
exports.dateFunctions = dateFunctions;